import clone from 'clone';

import {
    CANCEL_NOTIFICATION_START, CANCEL_NOTIFICATION_SUCCESS, CANCEL_NOTIFICATION_FAILURE,
    FETCH_NOTIFICATIONS, FETCH_NOTIFICATIONS_SUCCESS, FETCH_NOTIFICATIONS_FAILURE,
    FETCH_SCHEDULED_NOTIFICATIONS, FETCH_SCHEDULED_NOTIFICATIONS_SUCCESS, FETCH_SCHEDULED_NOTIFICATIONS_FAILURE,
    SEND_NOTIFICATION, SEND_NOTIFICATION_SUCCESS, SEND_NOTIFICATION_FAILURE,
    CLEAR_NOTIFICATION, EMPTY_NOTIFICATION, SET_NOTIFICATION
} from './constants';

import { request, requestConfig } from 'utils/request';
import { PATHS } from 'utils/paths';

export const clearNotification = () => ({
    type: CLEAR_NOTIFICATION
});

export const emptyNotification = () => ({
    type: EMPTY_NOTIFICATION
});

const cancelNotificationStart = () => ({
    type: CANCEL_NOTIFICATION_START
});

const cancelNotificationSuccess = () => ({
    type: CANCEL_NOTIFICATION_SUCCESS
});

const cancelNotificationFailure = (error) => ({
    type: CANCEL_NOTIFICATION_FAILURE,
    error
});

const fetchNotifications = (hideSpinner) => ({
    type: FETCH_NOTIFICATIONS,
    hideSpinner
});

const fetchNotificationsSuccess = (data, meta) => ({
    type: FETCH_NOTIFICATIONS_SUCCESS,
    data,
    meta
});

const fetchNotificationsFailure = (error) => ({
    type: FETCH_NOTIFICATIONS_FAILURE,
    error
});

const fetchScheduledNotifications = () => ({
    type: FETCH_SCHEDULED_NOTIFICATIONS
});

const fetchScheduledNotificationsSuccess = (data) => ({
    type: FETCH_SCHEDULED_NOTIFICATIONS_SUCCESS,
    data
});

const fetchScheduledNotificationsFailure = (error) => ({
    type: FETCH_SCHEDULED_NOTIFICATIONS_FAILURE,
    error
});

const sendNotification = () => ({
    type: SEND_NOTIFICATION
});

const sendNotificationSuccess = () => ({
    type: SEND_NOTIFICATION_SUCCESS
});

const sendNotificationFailure = (error) => ({
    type: SEND_NOTIFICATION_FAILURE,
    error
});

export const setNotification = (data) => ({
    type: SET_NOTIFICATION,
    data
});


/**
 *  ASYNC ACTIONS
 */
export const cancelNotification = (id) => (dispatch, getStore) => {
    dispatch(cancelNotificationStart());

    return request(PATHS.notifications.cancel(id), requestConfig('DELETE', null, getStore().auth.token))
        .then((response) => {
            dispatch(cancelNotificationSuccess());
            return response;
        })
        .catch((error) => {
            console.log('error cancelling notification', error);
            error.friendlyMessage = 'There was an error cancelling your notification. Please try again.';
            dispatch(cancelNotificationFailure(error));
            throw error;
        });
};

export const getNotifications = (isUpdate) => (dispatch, getStore) => {
    dispatch(fetchNotifications(isUpdate));

    let page = 0;

    if(isUpdate) {
        page = getStore().notifications.allMetadata.page + 1;
    }

    return request(PATHS.notifications.get(page, null, true), requestConfig('GET', null, getStore().auth.token))
        .then((response) => {
            let rows = response.data;
            if(isUpdate) {
                rows = getStore().notifications.all.concat(rows);
            }
            dispatch(fetchNotificationsSuccess(rows, { page }));
            return response;
        })
        .catch((error) => {
            console.log('error getting notifications', error);
            error.friendlyMessage = 'There was an error getting your notifications. Please try again.';
            dispatch(fetchNotificationsFailure(error));
            return error;
        });
};

export const getScheduledNotifications = () => (dispatch, getStore) => {
    dispatch(fetchScheduledNotifications());

    return request(PATHS.notifications.get(0, 100, false), requestConfig('GET', null, getStore().auth.token))
        .then((response) => {
            dispatch(fetchScheduledNotificationsSuccess(response.data));
            return response;
        })
        .catch((error) => {
            console.log('error getting notifications', error);
            error.friendlyMessage = 'There was an error getting your notifications. Please try again.';
            dispatch(fetchScheduledNotificationsFailure(error));
            return error;
        });
};

export const postNotification = (notificationType) => (dispatch, getStore) => {
    dispatch(sendNotification());

    let notification = clone(getStore().notifications.notification);

    if(notificationType === 'newsfeed' && !notification.url && notification.textUrl) {
        notification.url = notification.textUrl;
    }

    let reqVerb = 'POST';
    let path = PATHS.notifications.send(notificationType);

    if(notification.id) {
        reqVerb = 'PUT';
        path = PATHS.notifications.send(notificationType, notification.id);
    }

    return request(path, requestConfig(reqVerb, notification, getStore().auth.token))
        .then((response) => {
            dispatch(sendNotificationSuccess());
            return response;
        })
        .catch((error) => {
            console.log('error sending notification', error);
            error.friendlyMessage = 'There was an error sending your notification. Please try again.';
            dispatch(sendNotificationFailure(error));
            throw error;
        });
};



// WEBPACK FOOTER //
// ./src/containers/NotificationsPage/store/actions.js